import React, { useEffect, useState } from 'react';
import CustomModal from '../../../Shared/components/CustomModal';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import CardsCompareTable from './table';
import CardsListCompareTableCloseButton from './header';

const CardsListCompareTable = ({ cards }) => {
  const history = useHistory();
  const location = useLocation();
  const [selectedCards, setSelectedCards] = useState([]);

  useEffect(() => {
    const query = queryString.parse(location.search, { arrayFormat: 'comma' });
    const ids = query?.comparedCards || [];
    setSelectedCards(cards.filter((card) => ids.includes(card.id)));
  }, [location?.search]);

  const onClose = () => {
    history.push(location.pathname);
  };

  return (
    <CustomModal
      onClose={onClose}
      visible={selectedCards.length > 1}
      background={'#FFFFFF'}
      color={'#000'}
    >
      <CardsListCompareTableCloseButton onClick={onClose} />
      <CardsCompareTable cards={selectedCards} />
    </CustomModal>
  );
};

export default CardsListCompareTable;
